(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/* global module, _, Toasts, textareaSurroundSelection */

(function () {
    'use strict';

    module.exports = function (instance) {

        return {
            'default': function($target, photos, ideabook, size, isLast) {

                if (isLast) {
                    instance.hide();
                }

                Toasts.pushToast('Фотографиии успешно загружены', 'success', ideabook.url);
            },

            'redirect': function($target, photos, ideabook, size, isLast) {

                if (_(ideabook.url).isString() && isLast) {
                    instance.posting(true);
                    document.location = ideabook.url;
                }
            },

            'redirect-to-listing': function($target, photos, ideabook, size, isLast) {

                if (isLast) {
                    var url = ideabook.url.substring(0, ideabook.url.length - 1);
                    url = url.substring(0, url.lastIndexOf("/")) + '/';

                    instance.posting(true);
                    document.location = url;
                }
            },

            'insert-to-bb': function($target, photos, ideabook, size, isLast) {

                if (isLast) {
                    instance.hide();
                }

                // Если понадобится, надо будет вынести селектор текстареи в дата-атрибут
                var $textarea = $target.closest('.js-image-upload-wrap').find('textarea');

                if ($textarea.length) {
                    var bbCode = _.reduce(photos, function (result, photo) {
                        return result + '[photo]' + photo.id + '[/photo]';
                    }, '');
                    textareaSurroundSelection($textarea, bbCode, '');
                }
            }
        };
    };

})();
},{}],2:[function(require,module,exports){
/* global module, _, $, Photo, ko, debug, Toasts, FileAPI */

module.exports = function (Section, Photo, addPhotos, instance, removePhoto, $root) {
    'use strict';

    var section = new Section('direct-upload', 'С компьютера', 'icon-imac', 'Загрузить');
    return _.extend(
        section,
        (function() {
            var extra = {};

            function countDown () {
                instance.pendingPhotosCount(instance.pendingPhotosCount() - 1);
                if (instance.pendingPhotosCount() === 0) {
                    instance.pendingPhotosMax(0);
                }
            }

            function throwError (errorMessage) {
                countDown();
                Toasts.pushToast(errorMessage, 'fail', undefined, 10000);
                debug.error(errorMessage);
            }

            extra.handleFilesOnButton = function (data, event) {
                var files = FileAPI.getFiles(event);
                gotFiles(files);
                FileAPI.reset(event.currentTarget);
            };

            if (FileAPI.support.dnd) {

                $root.find('.js-drop-zone').dnd(
                    function (hovered) {
                        $(this).find('.drop-zone').toggleClass('drop-zone_drop-hover', hovered);
                    },
                    function (files) {
                        if (instance.selectedSection() === 'direct-upload') {
                            gotFiles(files);
                        }
                    }
                );
            }

            function gotFiles(files) {
                files.reverse();

                if (instance.insertOnlyOne()) {
                    files = [_(files).last()];
                }

                debug.log('Got files...', files);

                instance.pendingPhotosMax(files.length);
                instance.pendingPhotosCount(instance.pendingPhotosMax());

                FileAPI.each(files, processFile);
            }

            function processFile (file) {
                var localPhoto = new Photo(undefined, undefined, undefined, undefined);

                var $readed      = $.Deferred();
                var $gotDataURI  = $.Deferred();
                var $imgUploaded = $.Deferred();

                if (!/image\//.test(file.type)) {
                    $readed.reject('Фаил «' + file.name + '» не является изображением');
                }
                if (file.size >= 5*FileAPI.MB) {
                    $readed.reject('Фаил «' + file.name + '» больше 5 МБ');
                }
                else {
                    if (file.size === void 0) {
                        debug.log('File size is unknown', file);
                    }

                    $readed.resolve(file);
                }

                $.when($readed)
                    .fail(function(errorMessage) {
                        throwError(errorMessage);
                    })
                    .done(function(file) {
                        addPhotos([localPhoto]);
                        debug.log('... file is ok, Photo obj created!', file, localPhoto);

                        if (Modernizr.datauri) {

                            FileAPI.readAsDataURL(file, function (event) {
                                if (event.type === 'error') {
                                    $gotDataURI.resolve(undefined);
                                }
                                if (event.type === 'load') {
                                    $gotDataURI.resolve(event.result);
                                }
                            });
                        }
                        else {
                            $gotDataURI.resolve(undefined);
                        }
                    });

                $.when($gotDataURI)
                    .fail(function(errorMessage) {
                        throwError(errorMessage);
                    })
                    .done(function(dataURI) {
                        if (_(dataURI).isString()) {
                            localPhoto.thumbnailSrc(dataURI);
                            debug.log('... data url is fine!', file, dataURI);
                        }

                        debug.log('Saving photos to backend...', file);

                        if (_(instance.uploadByFileRoute).isUndefined()) {
                            debug.error('uploadByFileRoute is undefined. I can’t send photo to nowhere');
                            $readed.reject('Что-то пошло не так, пожалуйста попробуйте позже');
                            return false;
                        }

                        FileAPI.upload({
                            url      : instance.uploadByFileRoute,
                            files    : { image: file },
                            complete : function (error, xhr) {
                                if (!error) {
                                    $imgUploaded.resolve(file, xhr);
                                }
                                else {
                                    debug.error('... and it is failed', error, xhr);
                                    $imgUploaded.reject('Что-то пошло не так, пожалуйста попробуйте позже');
                                }
                            }
                        });
                    });

                $.when($imgUploaded)
                    .fail(function(errorMessage) {
                        throwError(errorMessage);
                    })
                    .done(function(file, xhr) {
                        var ResponseJSON = JSON.parse(xhr.response);
                        localPhoto.src = ResponseJSON.url;
                        localPhoto.thumbnailSrc(ResponseJSON.thumb_url);

                        countDown();

                        debug.log('... saved', file, localPhoto.src);
                    });
            }

            return extra;
        })()
    );
};

},{}],3:[function(require,module,exports){
/* global $, _, ko, debug, Modernizr, Modal, Toasts, Tooltip, require, whichTransitionEnd,
   textareaSurroundSelection,
   FileAPI,
*/

$(function () {
    "use strict";

    var transitionend = whichTransitionEnd();
    var $root         = $('#photo-upload-overlay');

    var photoUploadOverlay = function () {

        var instance = this;

        instance.$caller = undefined;

        //// Specific
        instance.withoutSidebar = ko.observable(false);

        //// Routes
        instance.innerTemplateRoute     = '/image_upload/modal/';
        instance.uploadToRoute          = '/image_upload/multiple/save/';
        instance.uploadFromUrlRoute     = undefined;
        instance.uploadByFileRoute      = undefined;
        instance.ideabookCreateRoute    = undefined;
        instance.getIdeabookPhotosRoute = '/image_upload/ideabook/';
        instance.postVkLinkRoute        = undefined;

        //// Ideabooks

        function Ideabook (name, id, special, isNew) {
            this.id      = id;                  // Number
            this.name    = ko.observable(name); // String
            this.special = special || false;    // Boolean
            this.isNew   = isNew || false;      // Boolean
        }

        function addIdeabooks (ideabooks) {
            if (!_(ideabooks).isArray() && _(ideabooks).isObject()) {
                ideabooks = [ideabooks];
            }

            instance.allIdeabooks(_.union(ideabooks, instance.allIdeabooks()));
            debug.log('Ideabooks added', ideabooks);
        }

        function getIdeabookById (id) {
            return _(instance.allIdeabooks()).findWhere({id: id});
        }

        function dismissIdeabookCreation () {
            instance.selectedIdeabook(
                instance.ideabooks()[
                    instance.ideabooks().indexOf(_(instance.ideabooks()).findWhere({isNewIdeabook: true})) + 1
                ]
            );
        }

        function insertIdeabooksAtInition () {
            var ideabooks = [];
            _(window.PhotoUploadOverlaySettings.ideabooks).each(function(ideabook) {
                ideabooks.push(new Ideabook(ideabook.name, ideabook.id, ideabook.special));
            });
            addIdeabooks(ideabooks);
            removePropertyFromWindowOptions('ideabooks');

            _.defer(function() {
                if (_(instance.selectedIdeabook()).isObject() && instance.selectedIdeabook().isNewIdeabook) {
                    instance.selectedIdeabook(instance.ideabooks()[1]);
                }
            });
        }

        function createNewIdeabook () {

            var postData = {
                'ideabook[_csrf_token]' : $root.find('[name="_csrf_token"]').val(),
                'ideabook[name]'        : _.trim(instance.newIdeabookName())
            };

            debug.log('Saving ideabook to backend...', postData);

            return $.post(instance.ideabookCreateRoute, postData)
                .fail(function() {
                    debug.error('... and it’s failed!');
                    var errorMessage = 'Что-то пошло не так, попробуйте позже';
                    Toasts.pushToast(errorMessage, 'fail', undefined, 10000);
                })
                .complete(function(data) {
                    var response = JSON.parse(data.responseText);
                    if (_(response).isObject() && !_(response.id).isUndefined()) {
                        var newIdeabook = new Ideabook(_.trim(instance.newIdeabookName()), Number(response.id), false, true);
                        debug.log('... and it’s done!', newIdeabook);
                        addIdeabooks([newIdeabook]);
                        dismissIdeabookCreation();
                    }
                    else {
                        debug.error('... and id is unknown. Can’t create ideabook with unkown name');
                    }
                });
        }

        function removeIdeabookById (id) {
            if (Boolean(_(instance.allIdeabooks()).findWhere({id: id}))) {
                instance.allIdeabooks(
                    _(instance.allIdeabooks()).without(
                        _(instance.allIdeabooks()).findWhere({id: id})
                    )
                );
            }
        }

        instance.allIdeabooks      = ko.observableArray([]);    // Array
        instance.hiddenIdeabooks   = ko.observableArray([]);    // Array
        instance.hideSpecials      = ko.observable(false);      // Boolean
        instance.specificIdeabook  = ko.observable(undefined);  // Number
        instance.selectedIdeabook  = ko.observable(undefined);  // Object
        instance.isOnlyNewIdeabook = ko.observable(false);      // Boolean
        instance.newIdeabookName   = ko.observable('');         // String

        instance.Ideabook          = Ideabook;
        instance.addIdeabooks      = addIdeabooks;

        // Array
        instance.ideabooks = ko.computed(function() {

            return _.union(
                _.extend(
                    new Ideabook('Новая коллекция', 0),
                    (function() {
                        var extra = {};
                        extra.isNewIdeabook = true;
                        return extra;
                    })()
                ),
                _(instance.allIdeabooks()).chain()
                .map(function(ideabook) {
                    if (instance.hideSpecials() && ideabook.special) {
                        instance.hiddenIdeabooks.push(ideabook.id);
                    }
                    return ideabook;
                })
                .filter(function(ideabook) {
                    return instance.hiddenIdeabooks().indexOf(ideabook.id) === -1;
                })
                .filter(function(ideabook) {
                    if (_(instance.specificIdeabook()).isNumber()) {
                        if (ideabook.id === instance.specificIdeabook()) {
                            instance.selectedIdeabook(ideabook);
                            return ideabook.id === instance.specificIdeabook();
                        }
                    }
                    else {
                        return true;
                    }
                })
                .value()
            );

        }, instance);

        // Boolean
        instance.isCreatingNewIdeabook = ko.computed(function() {
            return (_(instance.selectedIdeabook()).isObject() && instance.selectedIdeabook().isNewIdeabook) ||
                   instance.isOnlyNewIdeabook() ||
                   instance.ideabooks().length < 2;
        }, instance);

        instance.isCreatingNewIdeabook.subscribe(function(newIsSelected) {
            if (newIsSelected) {
                _.defer(function() {
                    $root.find('.photo-upload-overlay__ideabook-input').focus();
                });
            }
            else {
                instance.newIdeabookName('');
            }
        });

        instance.dismissIdeabookCreation = dismissIdeabookCreation;
        instance.getIdeabookById         = getIdeabookById;
        instance.removeIdeabookById      = removeIdeabookById;

        //// Tooltip

        instance.tooltip = (
            new Tooltip(
                (
                    '<div class="headline headline_h5 headline_base-font">Опишите ваши&nbsp;фотографии</div>' +
                    '<p>Невесты будут чаще&nbsp;находить ваши&nbsp;фото в&nbsp;разделе «Фотоидеи»</p>' +
                    '<p class="muted">Описание не&nbsp;должно содержать контактные данные, ссылки, рекламные лозунги</p>'
                ),
                undefined,
                true,
                '',
                true,
                'tooltip_transparent photo-upload-overlay__tooltip'
            )
        );

        instance.tooltipPhotoIndex = undefined;
        var tooltipDescriptionWatchers = [];

        var disposeTooltipDescriptionWatchers = function () {
            _(tooltipDescriptionWatchers).each(function(watcher) {
                watcher.dispose();
                tooltipDescriptionWatchers = _(tooltipDescriptionWatchers).without(watcher);
            });
        };

        instance.moveTooltip = function (photos) {

            if (instance.tooltip.shown()) {
                disposeTooltipDescriptionWatchers();

                var $tooltipHolder = $($root.find('.media__description')
                    .filter(function() {
                        return $(this).val().length < 1;
                    })
                    .first()
                ).parent();

                if ($tooltipHolder.length > 0) {
                    debug.log('Tooltip is shown, it time to move it...', instance.tooltip);

                    if ($tooltipHolder.is('.grid__cell')) {
                        instance.tooltipPhotoIndex = $tooltipHolder.index();
                    }
                    else {
                        instance.tooltipPhotoIndex = $tooltipHolder.closest('.grid__cell').index();
                    }

                    debug.log('Tooltip photo index is setted', instance.tooltipPhotoIndex);

                    tooltipDescriptionWatchers.push(
                        photos[instance.tooltipPhotoIndex].description.subscribe(function(description) {
                            if (description.length > 3) {
                                instance.tooltip.hide();
                                disposeTooltipDescriptionWatchers();
                            }
                        })
                    );

                    debug.log('Moving tooltip to', $tooltipHolder);
                    instance.tooltip.moveTo($tooltipHolder);
                }
            }
        };

        $root.on('PhotoUploadOverlay::photosAdded', function() {
            instance.moveTooltip(instance.photos());
        });
        $root.on('PhotoUploadOverlay::minorSectionChanged', function() {
            instance.moveTooltip(instance.photos());
        });
        $root.on('PhotoUploadOverlay::vkAlbumChange', function(event, photos) {
            instance.moveTooltip(photos);
        });

        //// Photos

        function Photo (id, src, thumbnailSrc, description) {
            var photo = this;

            var rotatePhoto = function(operand, $node) {
                $node.css('ponter-events', 'none');
                var degree = photo.rotation() + operand;
                if (Math.abs(degree) === 360) {
                    degree = 0;
                }
                photo.rotation(degree);
                debug.log('Photo rotated', degree, photo, $node);
            };

            photo.id           = id;
            photo.src          = src;
            photo.thumbnailSrc = ko.observable(thumbnailSrc || photo.src || '');
            photo.description  = ko.observable(description || '');

            photo.rotation      = ko.observable(0);
            photo.rotateLeft    = function (data, event) {
                rotatePhoto(-90, $(event.target).parents('.media_rotateable'));
            };
            photo.rotateRight   = function (data, event) {
                rotatePhoto(90, $(event.target).parents('.media_rotateable'));
            };
            photo.rotationClass = ko.computed(function() {
                return 'media_rotate_' + photo.rotation();
            }, photo);
        }

        function addPhotos (photos, isSelected) {
            if (!_(photos).isArray() && _(photos).isObject()) {
                photos = [photos];
            }

            instance.photos(_.union(photos, instance.photos()));

            if (!isSelected) {
                debug.log('Photos added', photos);

                _.defer(function() {
                    $root.trigger('PhotoUploadOverlay::photosAdded', [photos]);
                });
            }
        }

        function removePhoto (photo) {
            instance.photos(_(instance.photos()).without(photo));
        }

        instance.photos       = ko.observableArray([]); // Array
        instance.cachedPhotos = []; // Array

        instance.cacheInsertedPhotos = function () {
            instance.cachedPhotos = instance.photos();
            instance.photos([]);
        };

        instance.getInsertedButtonOutACache = function () {
            instance.photos(instance.cachedPhotos);
            instance.cachedPhotos = [];
        };

        instance.addPhotos    = addPhotos;
        instance.removePhoto  = removePhoto;

        //// Insertion

        instance.insertOnlyOne      = ko.observable(false);
        instance.limit              = ko.observable(20);
        instance.selectionLimit     = ko.observable(false);
        instance.posting            = ko.observable(false);
        instance.pendingPhotosMax   = ko.observable(0);
        instance.pendingPhotosCount = ko.observable(0);
        instance.progressbarVisible = ko.computed(function () {
            return instance.pendingPhotosMax() > 0;
        }, instance);
        instance.progressbarWidth   = ko.computed(function () {
            var width = (100 - (100 / (instance.pendingPhotosMax() / instance.pendingPhotosCount())));
            if (width > 100) {
                width = 100;
            }
            return width + '%';
        }, instance);


        var selectionLimitWatcher;
        instance.selectionLimit.subscribe(function (isLimited) {
            if (isLimited) {
                selectionLimitWatcher = instance.photos.subscribeChanged(function (newPhotos, oldPhotos) {
                    if (newPhotos.length > instance.limit()) {
                        instance.photos(oldPhotos);

                        if (Toasts.toasts().length < 1) {
                            Toasts.pushToast("Нельзя выбрать более " + instance.limit() + " фотографий за раз", 'fail');
                        }

                        try {
                            _(newPhotos).first().selected(false);
                        }
                        catch (error) {}
                    }
                });
            }
            else {
                if (_(selectionLimitWatcher).isFunction()) {
                    selectionLimitWatcher.dispose();
                }
            }
        });

        instance.insertionCallback  = 'default';
        instance.insertionCallbacks = require('./callbacks')(instance);

        instance.registerCallback = function (callbackObject) {
            if (_(callbackObject).isObject()) {
                instance.insertionCallbacks[callbackObject.name] = callbackObject.callbackFunction;
            }
            else {
                debug.error('Can not register callback, callbackObject is not a object', callbackObject);
            }
        };

        function getSerializedData () {
            var data = {};

            data.ideabook_id = instance.selectedIdeabook().id;
            data.photos = [];

            _(instance.photos()).each(function(photo, index) {
                data.photos[index] = {};
                data.photos[index].src = photo.src;
                data.photos[index].name = _.trim(photo.description());
                data.photos[index].rotate = photo.rotation() >= 0 ? photo.rotation() : 360 + photo.rotation();
            });

            if (instance.limit()) {
                data.limit = instance.limit();
            }

            if (_(instance.additionalParams).isObject() && _(instance.additionalParams.uploadToRoute).isObject()) {
                _(instance.additionalParams.uploadToRoute).each(function (value, key) {
                    data[key] = value;
                });
            }

            data.photos = data.photos.reverse();
            data.photos = JSON.stringify(data.photos);

            return data;
        }

        instance.insert = function (isLast) {

            if (_(isLast).isUndefined()) {
                isLast = true;
            }

            var $createIdeabookIfNeeded     = $.Deferred();
            var $postToImageServiceIfNeeded = $.Deferred();
            var $postToServerIfNeeded       = $.Deferred();
            var $everythingDone             = $.Deferred();

            if (instance.isCreatingNewIdeabook()) {
                createNewIdeabook()
                    .complete(function() {
                        _.defer(function() {
                            $createIdeabookIfNeeded.resolve();
                        });
                    });
            }
            else {
                $createIdeabookIfNeeded.resolve();
            }

            $.when($createIdeabookIfNeeded).done(function() {

                if (_(instance.photos()).filter(function(photo) { return !photo.src; }).length > 0) {

                    var photosWithoutSrc = _(instance.photos()).filter(function(photo) { return !photo.src; });
                    debug.info('Uploading photos to image service...', photosWithoutSrc);

                    var shutError = function (photo, src) {
                        debug.error('... photo upload failed...', photo, src);
                        Toasts.pushToast("Что-то пошло не так, файл не будет загружен", 'fail', undefined, 10000);
                        if (_(photo.selected()).isFunction()) {
                            photo.selected(false);
                        }
                        else {
                            removePhoto(photo);
                        }
                    };

                    var uploadedPhotos = [];

                    if (instance.pendingPhotosMax() === 0) {
                        instance.pendingPhotosMax(photosWithoutSrc.length);
                        instance.pendingPhotosCount(instance.pendingPhotosMax());
                    }

                    _(photosWithoutSrc).each(function (photo) {
                        var src = '';

                        if (_(photo.originalVkSrc).isString()) {
                            src = photo.originalVkSrc;
                        }
                        else if (_(photo.thumbnailSrc).isString()) {
                            src = photo.thumbnailSrc;
                        }
                        else {
                            src = photo.thumbnailSrc();
                        }

                        $.ajax({
                            crossDomain : true,
                            cache: false,
                            type: 'POST',
                            url: instance.uploadFromUrlRoute,
                            data: { url : src },
                            dataType: 'json'
                        })
                            .fail(function() {
                                shutError(photo, src);
                            })
                            .complete(function(data) {
                                if (_(data.responseJSON.url).isString()) {
                                    photo.src = data.responseJSON.url;
                                    instance.pendingPhotosCount(instance.pendingPhotosCount() - 1);
                                    uploadedPhotos.push(photo);
                                    debug.log('... photo uploaded...', photo, src);

                                    if (uploadedPhotos.length === instance.photos().length) {
                                        debug.log('... all photos uploaded...', uploadedPhotos);
                                        uploadedPhotos = [];
                                        $postToImageServiceIfNeeded.resolve();
                                    }
                                }
                                else {
                                    shutError(photo, src);
                                }
                            });
                    });
                }
                else {
                    $postToImageServiceIfNeeded.resolve();
                }
            });

            $.when($postToImageServiceIfNeeded).done(function() {

                if (_(instance.photos()).filter(function(photo) { return !photo.id; }).length > 0) {
                    var postData = getSerializedData();
                    instance.posting(true);

                    debug.log('Saving photos to backend...', postData);

                    return $.post(instance.uploadToRoute, postData)
                    .always(function() {
                        instance.posting(false);
                    })
                    .fail(function() {
                        debug.error('... and it’s failed!');
                        var errorMessage = 'Что-то пошло не так, попробуйте позже';
                        Toasts.pushToast(errorMessage, 'fail', undefined, 10000);
                    })
                    .done(function(data) {
                        debug.log('... saved!', data);

                        _(instance.photos()).map(function(photo) {
                            if (!photo.id) {
                                var serverSavedPhoto = _(data.photos).findWhere({src: photo.src});
                                if (serverSavedPhoto) {
                                    photo.id = Number(serverSavedPhoto.id);
                                }
                            }

                            return photo;
                        });

                        if ('undefined' !== typeof window.Tracker) {
                            window.Tracker.pushEvent(
                                {
                                    category : 'Photo upload overlay',
                                    action   : 'Photo uploaded',
                                    label    : _(instance.selectedSection()||'').humanize(),
                                    value    : instance.photos().length
                                }
                            );
                        }

                        if (Boolean(_(allSections).findWhere({name: 'insert-from-ideabook'}))) {
                            var ideabooks = _(allSections).findWhere({name: 'insert-from-ideabook'}).ideabooks();
                            var ideabook  = _(ideabooks).findWhere({id: instance.selectedIdeabook().id});
                            if (!ideabook.loading()) {
                                ideabook.addPhotos(instance.photos(), true);
                            }
                        }

                        instance.pendingPhotosCount(instance.pendingPhotosCount() - 1);

                        $postToServerIfNeeded.resolve(data.ideabook_url);
                    });
                }
                else {
                    $postToServerIfNeeded.resolve(undefined);
                }
            });

            $.when($postToServerIfNeeded).done(function(ideabook_url) {

                function getFrozenPhotos () {
                    var photos = _(instance.photos()).map(function(photo) {
                        return {
                            id           : photo.id,
                            src          : photo.src,
                            thumbnailSrc : photo.thumbnailSrc()
                        };
                    });

                    if (instance.limit()) {
                        photos = _(photos).first(instance.limit());
                    }

                    return photos;
                }

                function getIdeabookObject () {
                    return {
                        id   : instance.selectedIdeabook().id || Number(ideabook_url.replace(/.*?\/(\d+)\/$/, '$1')) || undefined,
                        url  : ideabook_url || undefined,
                        name : instance.newIdeabookName() || instance.selectedIdeabook().name()
                    };
                }

                function shutCallback (callbackName) {
                    instance.insertionCallbacks[callbackName](
                        instance.$caller,
                        getFrozenPhotos(),
                        getIdeabookObject(),
                        instance.photos().length,
                        isLast
                    );
                    $everythingDone.resolve();
                }

                if (_(instance.insertionCallbacks[instance.insertionCallback]).isFunction()) {
                    shutCallback(instance.insertionCallback);
                }
                else {
                    debug.error('Unknown callback called! Shutting default');
                    shutCallback('default');
                }
            });

            $everythingDone.done(function() {
            });

            return $everythingDone;
        };

        instance.ifInsertIsNotAlowwed = ko.computed(function() {
            return instance.photos().length < 1 ||
                   instance.isCreatingNewIdeabook() && instance.newIdeabookName().length < 1;
        }, instance);

        instance.insertionButtonText = ko.observable('Сохранить и вставить');

        instance.insertionButtonClasses = ko.computed(function() {
            var result = '';
            if (instance.ifInsertIsNotAlowwed()) {
                result = ' button_active button_disabled';
            }
            if (instance.posting()) {
                result = ' button_active';
            }
            return result;
        }, instance);

        //// Sections

        function Section (name, text, icon, parent) {
            this.name     = name;                 // String
            this.text     = text;                 // String
            this.icon     = icon;                 // String
            this.selected = ko.observable(false); // Boolean
            this.parent   = parent;               // String
        }

        var allSections = require('./sections.js')(Section, Photo, addPhotos, instance, removePhoto, $root);

        instance.hiddenSections  = ko.observableArray(['mass-import-from-vk', 'import-from-vk']); // Array
        instance.selectedSection = ko.observable(allSections[0].name);          // String

        instance.selectedSection.subscribeChanged(function(selectedSection, oldSection) {

            if ((selectedSection === 'import-from-vk' || selectedSection === 'insert-from-ideabook') &&
               !(oldSection      === 'import-from-vk' || selectedSection === 'insert-from-ideabook')
            ) {
                instance.cacheInsertedPhotos();
            }

            if ((selectedSection === 'upload-via-link' || selectedSection === 'direct-upload') &&
               !(oldSection      === 'upload-via-link' || oldSection      === 'direct-upload')
            ) {
                instance.getInsertedButtonOutACache();
            }

            _.defer(function() {
                $root.trigger('PhotoUploadOverlay::RecalcScrollerLimits');
            });

            if ((instance.getSectionContext(selectedSection).parent || '') === (instance.getSectionContext(oldSection).parent || '')) {
                _.defer(function() {
                    $root.trigger('PhotoUploadOverlay::minorSectionChanged');
                });
            }
        });

        instance.sections = ko.computed(function() {
            return _(allSections).chain()
                .map(function(section) {
                    section.selected(section.name === instance.selectedSection());
                    return section;
                })
                .filter(function(section) {
                    return instance.hiddenSections().indexOf(section.name) === -1;
                })
                .value();
        }, instance);

        instance.sectionsByParent = ko.computed(function() {

            return _(instance.sections()).chain()
                .map(function(section) {
                    return section.parent;
                })
                .uniq()
                .map(function(parentName) {
                    return {
                        name: parentName,
                        subsections: _(instance.sections()).filter(function(subsection) {
                            return subsection.parent === parentName;
                        })
                    };
                })
                .value();

        }, instance);

        instance.sections.subscribe(function(sections) {
            if (!_(sections).chain().findWhere({name: instance.selectedSection()}).isObject().value()) {
                instance.changeSection(sections[0]);
                sections[0].selected(true);
            }
        });

        instance.changeSection = function (section) {
            instance.selectedSection(section.name);
        };
        instance.getSectionContext = function (sectionName) {
            return _.findWhere((allSections), {name: sectionName});
        };

        //// Everything

        instance.headlineText = ko.computed(function () {
            if (instance.selectedSection() === 'mass-import-from-vk') {
                return 'Импортировать альбомы из Вконтакте';
            }
            else if (instance.selectionLimit()) {
                return 'Выберите не более ' + instance.limit() + ' фотографий';
            }
            else {
                return 'Выберите фотографии';
            }
        }, instance);

        function removePropertyFromWindowOptions (propertyName) {
            delete window.PhotoUploadOverlaySettings[propertyName];
            if (_(window.PhotoUploadOverlaySettings).keys().length < 1) {
                window.PhotoUploadOverlaySettings = undefined;
                try{
                    delete window.PhotoUploadOverlaySettings;
                }
                catch (e) {
                    window.PhotoUploadOverlaySettings = undefined;
                }
            }
        }

        function setTextsAtInition () {
            if (Boolean(window.PhotoUploadOverlaySettings) &&
                _(window.PhotoUploadOverlaySettings.texts).isObject()
            ) {
                setOptions(window.PhotoUploadOverlaySettings.texts, true);
                removePropertyFromWindowOptions('texts');
            }
        }

        function setRoutesAtInition () {
            if (Boolean(window.PhotoUploadOverlaySettings) &&
                _(window.PhotoUploadOverlaySettings.routes).isObject()
            ) {
                setOptions(window.PhotoUploadOverlaySettings.routes, true);
                removePropertyFromWindowOptions('routes');
            }
        }

        function setVKUrlAtInition () {
            if (Boolean(window.PhotoUploadOverlaySettings) &&
                Boolean(window.PhotoUploadOverlaySettings.userVkLink)
            ) {
                var sectionContext = instance.getSectionContext('import-from-vk');
                var url = window.PhotoUploadOverlaySettings.userVkLink;
                sectionContext.vkUrl(url);
                sectionContext.setVkSlug(url, false);
                removePropertyFromWindowOptions('userVkLink');
            }
        }

        function setOptsAtInition () {
            setTextsAtInition();
            setRoutesAtInition();
            insertIdeabooksAtInition();
            // setVKUrlAtInition();
        }

        function init () {
            var afterInit = $.Deferred();

            if (!instance.inited()) {

                debug.log('Photo upload overlay opened for the very first time. Initing...');
                $.get(instance.innerTemplateRoute)
                    .fail(function () {
                        debug.error('... and it’s failed!');

                        var errorMessage = 'Что-то пошло не так, попробуйте позже';
                        Toasts.pushToast(errorMessage, 'fail', undefined, 10000);
                        setTimeout(function() { hide(); }, 10000);
                    })
                    .complete(function (data) {
                        var $template = $(data.responseText);
                        var $target = $root.find('.photo-upload-overlay__before-init');
                        $template.appendTo($('body'));

                        var afterRender = $.Deferred();
                        ko.renderTemplate(
                            "PhotoUploadOverlayInner",
                            instance,
                            {
                                afterRender: function () {
                                    afterRender.resolve();
                                }
                            },
                            $target,
                            "replaceNode"
                        );

                        $.when(afterRender).then(function () {
                            debug.log('... Inited.');
                            instance.inited(true);
                            setOptsAtInition();
                            afterInit.resolve();
                            $root.trigger('PhotoUploadOverlay::inited');
                        });
                    });
            }
            else {
                afterInit.resolve();
            }

            return afterInit;
        }

        function setOptions (specificOptions, isSoftcore) {

            _(specificOptions).keys().forEach(function(keyName) {
                if (_(instance[keyName]).isFunction()) {
                    if (isSoftcore) {
                        if (instance[keyName]() === undefined) {
                            instance[keyName](specificOptions[keyName]);
                        }
                    }
                    else {
                        instance[keyName](specificOptions[keyName]);
                    }
                }
                else {
                    if (isSoftcore) {
                        if (instance[keyName] === undefined) {
                            instance[keyName] = specificOptions[keyName];
                        }
                    }
                    else {
                        instance[keyName] = specificOptions[keyName];
                    }
                }
            });
        }

        function reset () {
            instance.withoutSidebar(false);
            instance.photos([]);
            instance.cachedPhotos = [];
            instance.selectedSection(instance.sections()[0].name);
            instance.isOnlyNewIdeabook(false);
            instance.hiddenSections(['mass-import-from-vk', 'import-from-vk']);
            instance.posting(false);
            instance.additionalParams = null;
            instance.pendingPhotosMax(0);
            instance.pendingPhotosCount(0);
            instance.insertionButtonText('Сохранить и вставить');
            instance.hideSpecials(false);
            instance.insertOnlyOne(false);
            instance.specificIdeabook(undefined);
            instance.tooltipPhotoIndex = undefined;
            instance.tooltip.show();
            instance.scroller.minHeight(undefined);
            instance.scroller.maxHeight(undefined);

            instance.$caller = undefined;

            if (instance.isCreatingNewIdeabook()) {
                dismissIdeabookCreation();
            }

            $(window).off('resize.PhotoUploadOverlay');
            debug.log('Photo upload overlay data resetted', instance);
        }

        function show (specificOptions, $caller) {
            setOptions(specificOptions);

            if ('function' === typeof debug.log) {
                debug.log(
                    'Showing photo upload overlay',
                    specificOptions
                );
            }

            Modal.openModal($root.children());
            instance.shown(true);
            instance.$caller = $caller;

            init()
            .then(function () {
                $root.trigger('PhotoUploadOverlay::RecalcScrollerLimits');
                $(window).on('resize.PhotoUploadOverlay', function() {
                    $root.trigger('PhotoUploadOverlay::RecalcScrollerLimits', [true]);
                });
            });
        }

        function hide () {
            Modal.closeModal($root.children());
            instance.shown(false);

            if (!Modernizr.csstransitions) {
                reset();
            }
            else {
                $root.one(transitionend, function (event) {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    reset();
                });
            }
        }

        function getScrollerMaxHeight () {
            var $headline = $root.find('.photo-upload-overlay__headline');
            return $(window).outerHeight(true) - $headline.outerHeight(true);
        }

        function getScrollerMinHeight (currentHeight) {
            var minHeight = 624;
            var maxHeight = getScrollerMaxHeight();

            var $sidebar = $root.find('.photo-upload-overlay__sidebar');
            var sidebarMinHeight = minHeight;

            if ($sidebar.find('.fixed-panel__holder').length > 0) {
                sidebarMinHeight = $sidebar.find('.fixed-panel__holder').outerHeight(true) + $sidebar.find('.photo-upload-overlay__rules').outerHeight(true);
            }

            var paneMinHeight = minHeight > maxHeight ? maxHeight : minHeight;
            var result = sidebarMinHeight > paneMinHeight ? sidebarMinHeight : paneMinHeight;
            result = result > maxHeight ? maxHeight : result;

            return result > currentHeight ? result : currentHeight;
        }

        function getDialogButtonsRightOffset () {
            var $scroller = $root.find('.photo-upload-overlay__scroller');
            var offset = 0;

            if ($scroller.length > 0) {

                if ($scroller.get(0).scrollHeight > $scroller.outerHeight(true)) {
                    offset = getScrollbarWidth();
                }
            }

            return offset;
        }

        $root.on('PhotoUploadOverlay::RecalcScrollerLimits', function (event, isHard) {
            if (instance.inited() && instance.shown()) {

                var currentHeight;

                /*if (isHard) {
                 currentHeight = 0
                 }
                 else {
                 currentHeight = $root.find('.photo-upload-overlay__scroller').outerHeight();
                 } */
                currentHeight = 0;

                instance.scroller.minHeight(getScrollerMinHeight(currentHeight) + 'px');
                instance.scroller.maxHeight(getScrollerMaxHeight() + 'px');
                instance.scroller.dialogRightOffset(getDialogButtonsRightOffset() + 'px');
            }
        });

        instance.inited = ko.observable(false);
        instance.shown  = ko.observable(false);

        function getScrollbarWidth () {
            var width;

            if (width === undefined) {
                var $parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body');
                var $child  = $parent.children();
                width = $child.innerWidth() - $child.height(99).innerWidth();
                $parent.remove();
            }

            return width;
        }

        var $backdrop = $root.find('.modall__backdrop');

        function overflowiseBackdrop () {

            if (1216 >= $(window).outerWidth()) {
                $backdrop.css('bottom', getScrollbarWidth() + 'px');
            }
            else {
                $backdrop.css('bottom', '');
            }
        }

        instance.shown.subscribe(function(isShown) {

            _.defer(function() {
                var $layout = $('.layout');

                if (isShown) {
                    $layout.css('min-width', '0');
                    overflowiseBackdrop();
                    $(window).on('resize.PhotoUploadOverlay', function() {
                        overflowiseBackdrop();
                    });
                }
                else {
                    $layout.css('min-width', '');
                    $backdrop.css('bottom', '');
                    $(window).on('resize.PhotoUploadOverlay');
                }
            });
        });

        instance.show = show;
        instance.hide = hide;

        instance.scroller = {
            minHeight         : ko.observable(getScrollerMinHeight() + 'px'), // String
            maxHeight         : ko.observable(getScrollerMaxHeight() + 'px'), // String
            dialogRightOffset : ko.observable(getDialogButtonsRightOffset() + 'px')  // String
        };

    };

    //// Bindings

    var photoUploadOverlayInstance = new photoUploadOverlay();

    if ($root.length > 0) {
        $root.data('photoUploadOverlay', photoUploadOverlayInstance);
        ko.applyBindings(photoUploadOverlayInstance, $root[0]);
    }

    $(document).on('PhotoUploadOverlay::registerCallback', function (event, callbackObject, callback) {
        debug.log('Registering Callback', callbackObject, callback);
        photoUploadOverlayInstance.registerCallback(callbackObject);
        if (_(callback).isFunction()) {
            callback();
        }
    });

    $(document).on('PhotoUploadOverlay::addIdeabook', function (event, name, id, special) {
        photoUploadOverlayInstance.addIdeabooks(
            new photoUploadOverlayInstance.Ideabook(name, id, special)
        );
    });

    $(document).on('PhotoUploadOverlay::show', function (event, specificOptions, $caller) {

        if (!_(specificOptions).isObject()) {
            debug.error('Attempted to open photo upload overlay, but options is not a valid JSON', specificOptions, $caller);
        }
        else {
            photoUploadOverlayInstance.show(specificOptions, $caller);
        }
    });

    $(document).on('PhotoUploadOverlay::hide', function () {
        photoUploadOverlayInstance.hide();
    });

    $(document).on('click', '.js-open-photo-upload-overlay', function(event) {
        event.preventDefault();
        var specificOptions = $(this).data('photoUploadOverlayOptions');
        var $caller = $(this);
        $(document).trigger('PhotoUploadOverlay::show', [specificOptions, $caller]);
    });

    if (window.debug === window.console) {
        window.photoUploadOverlay = photoUploadOverlayInstance;
    }

});

},{"./callbacks":1,"./sections.js":5}],4:[function(require,module,exports){
/* global module, _, $, Photo, ko, debug, Toasts */

module.exports = function (Section, Photo, addPhotos, instance, removePhoto, $root) {
    'use strict';
    var section = new Section('insert-from-ideabook', 'Из коллекции', 'icon-gallery', 'Вставить');

    return _.extend(
        section,
        (function () {
            var extra = {};

            function IdeabookPhoto(id, src, thumbnailSrc) {
                var photo = new Photo(id, src, thumbnailSrc);
                return _.extend(
                    photo,
                    (function (photo) {
                        var ideabookPhoto = {};

                        ideabookPhoto.selected = ko.observable(false);

                        ideabookPhoto.selected.subscribe(function (isSelected) {
                            if (isSelected) {
                                addPhotos(photo, true);

                                if (instance.insertOnlyOne()) {
                                    instance.insert();
                                }
                            }
                            else {
                                removePhoto(photo);
                            }
                        });

                        ideabookPhoto.select = function () {
                            ideabookPhoto.selected(!ideabookPhoto.selected());
                        };

                        section.selected.subscribe(function () {
                            ideabookPhoto.selected(false);
                        });

                        return ideabookPhoto;
                    })(photo)
                );
            }

            function addPhotosToIdeabook(photos, ideabook, convert) {
                if (!_(photos).isArray() && _(photos).isObject()) {
                    photos = [photos];
                }

                if (Boolean(convert)) {
                    photos = photos.map(function (photo) {
                        return new IdeabookPhoto(photo.id, photo.src, photo.thumbnailSrc());
                    });
                }

                ideabook.photos(_.union(photos, ideabook.photos()));
                debug.log('Photos added to ideabook', photos, ideabook);
            }

            extra.ideabooks = ko.computed(function () {
                return _(instance.ideabooks()).chain()
                    .filter(function (ideabook) {
                        return !ideabook.isNewIdeabook;
                    })
                    .map(function (ideabook) {
                        ideabook.photos = ko.observableArray([]);
                        ideabook.loading = ko.observable(ideabook.isNew ? false : true);
                        ideabook.pending = false;

                        ideabook.photos.subscribe(function (photos) {
                            if (photos.length > 0) {
                                ideabook.loading(false);
                            }
                        });

                        ideabook.addPhotos = function (photos, convert) {
                            addPhotosToIdeabook(photos, ideabook, convert);
                        };

                        return ideabook;
                    })
                    .value();
            }, instance);

            function getIdeabookContextById(id) {
                return _(extra.ideabooks()).findWhere({id: id});
            }

            extra.selectedIdeabook = ko.computed(function () {
                if (Boolean(instance.selectedIdeabook())) {
                    return getIdeabookContextById(instance.selectedIdeabook().id);
                }
            }, instance);

            function getPhotosByAjax(id) {
                var $getted = $.get(instance.getIdeabookPhotosRoute + id + '/');
                var $gettedAndParsed = $.Deferred();

                $getted
                    .fail(function (response) {
                        debug.error("Ideabook photo failed", response);
                        Toasts.pushToast("Что-то пошло не так, попробуйте позже", 'fail', undefined, 10000);
                    })
                    .complete(function (response) {
                        if (_(response.responseJSON).isObject()) {
                            $gettedAndParsed.resolve(
                                _(response.responseJSON).map(function (photoJSON) {
                                    return new IdeabookPhoto(
                                        Number(photoJSON.id), String(photoJSON.src), String(photoJSON.thumb_src)
                                    );
                                })
                            );
                        }
                        else {
                            debug.error("Ideabook photo response JSON is not object", response);
                            Toasts.pushToast("Что-то пошло не так, попробуйте позже", 'fail', undefined, 10000);
                        }
                    });

                return $gettedAndParsed;
            }

            extra.selectedIdeabook.subscribe(function (selectedIdeabook) {
                debug.log('Ideabooks changed...', selectedIdeabook);
                if (Boolean(selectedIdeabook)) {
                    if (selectedIdeabook.photos().length < 1 && !selectedIdeabook.pending) {
                        debug.log('... and has no photos');
                        selectedIdeabook.pending = true;
                        getPhotosByAjax(selectedIdeabook.id)
                            .done(function (photos) {
                                addPhotosToIdeabook(photos, selectedIdeabook);
                                selectedIdeabook.pending = false;
                            });
                    }
                    else {
                        debug.log('... and all fine');
                    }
                }
            });

            return extra;
        })()
    );
};
},{}],5:[function(require,module,exports){
/* global module, require, _, $, Photo, ko, debug, Toasts */

module.exports = function (Section, Photo, addPhotos, instance, removePhoto, $root) {
    'use strict';

    var allSections = [];

    allSections.push(require('./insert-from-ideabook.js')(Section, Photo, addPhotos, instance, removePhoto, $root));
    allSections.push(require('./direct-upload.js')(Section, Photo, addPhotos, instance, removePhoto, $root));
    // allSections.push(require('./import-from-vk.js')(Section, Photo, addPhotos, instance, removePhoto, $root));
    allSections.push(require('./upload-via-link.js')(Section, Photo, addPhotos, instance, removePhoto, $root));
    // allSections.push(require('./mass-import-from-vk.js')(Section, Photo, addPhotos, instance, removePhoto, $root, allSections));

    return allSections;
};

},{"./direct-upload.js":2,"./insert-from-ideabook.js":4,"./upload-via-link.js":6}],6:[function(require,module,exports){
/* global module, _, $, Photo, ko, debug, Toasts, FileAPI */

module.exports = function (Section, Photo, addPhotos, instance, removePhoto, $root) {
    'use strict';

    var section = new Section('upload-via-link', 'Через ссылку', 'icon-link', 'Загрузить');
    return _.extend(
        section,
        (function() {
            var extra = {};
            extra.url     = ko.observable('');
            extra.sending = ko.observable(false);
            extra.error   = ko.observable(false);
            extra.classes = ko.computed(function () {
                var classes = '';

                if (extra.sending()) {
                    classes = ' button_active';
                }
                if (extra.url().length < 1 && !extra.sending()) {
                    classes = ' button_active button_disabled';
                }

                return classes;
            }, extra);

            extra.url.subscribe(function() {
                if (extra.error()) {
                    extra.error(false);
                }
            });

            extra.insertPhotoViaLink = function () {

                if (!/^https?:/.test(extra.url())) {
                    extra.url('http://' + extra.url());
                }

                var externalUrl = extra.url();

                if (_(instance.uploadFromUrlRoute).isUndefined()) {
                    debug.error('uploadFromUrlRoute is undefined. I can’t send photo to nowhere');
                    return false;
                }

                if (extra.url().length < 1 || extra.sending()) {
                    return false;
                }

                extra.sending(true);

                $.ajax({
                    crossDomain : true,
                    cache: false,
                    type: 'POST',
                    url: instance.uploadFromUrlRoute,
                    data: { url : extra.url() },
                    dataType: 'json'
                })
                    .always(function() {
                        extra.sending(false);
                        extra.url('');
                    })
                    .fail(function() {
                        extra.error(true);
                    })
                    .complete(function(data) {
                        if ( _(data.responseJSON).isObject() && _(data.responseJSON.url).isString() ) {
                            addPhotos([new Photo(undefined, data.responseJSON.url, externalUrl)]);
                        }
                    });
            };

            return extra;
        })()
    );
};
},{}]},{},[3])
//# sourceMappingURL=https://www.nevesta.info/js//photo-upload-overlay.bundle.js.map
